/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  FHPCalculatorService,
  IFHPCalculatorServiceMethods,
  IHeaderNavContentMethods,
  HeaderNavContentService,
  IKYCFormDataMethods,
  KYCFormDataService,
  ICreatePolicyMethods,
  CreatePolicyService,
  IKYCSubmitMethods,
  KYCSubmitService,
  IOfferDataMethods,
  OfferDataService,
} from "./components";

export type FHPPolicyPageAgent = IStaticPageContentMethods &
  IFHPCalculatorServiceMethods &
  IHeaderNavContentMethods &
  IKYCFormDataMethods &
  ICreatePolicyMethods &
  IKYCSubmitMethods &
  IOfferDataMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new FHPCalculatorService(),
    new HeaderNavContentService(),
    new KYCFormDataService(),
    new CreatePolicyService(),
    new KYCSubmitService(),
    new OfferDataService(),
  ];
};

export const getAgent = () => {
  return createAgent<FHPPolicyPageAgent>({
    plugins: getPlugins(),
  });
};
